import { LiveEventGuard } from './services/live-event.guard'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { LiveComponent } from './live.component'
import { LiveEventResolver } from '../shared/services/live-event.resolver'
import { LIVE_TAG } from './live-analytics.service'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: ':id',
        component: LiveComponent,
        canActivate: [LiveEventGuard],
        data: {
          segment: LIVE_TAG,
          shouldShowEventTicker: false,
          hideFooter: true,
          animation: 'none'
        },
        resolve: {
          liveEvent: LiveEventResolver
        }
      }
    ])
  ],
  exports: [RouterModule],
  providers: [LiveEventGuard]
})
export class LiveRoutingModule {}
